export default __webpack_public_path__ + "static/media/va.ecf9d743.svg";